// extracted by mini-css-extract-plugin
module.exports = {"modal":"SendForApprovalModal_modal__2uIVt"};